module.exports = __webpack_public_path__ + "media/images/h1ぴっかちゃん-36d83a954b3d0168737f6de389575d40.png";